import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=770e1354&scoped=true"
import script from "./AccountCenter.vue?vue&type=script&lang=js"
export * from "./AccountCenter.vue?vue&type=script&lang=js"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=770e1354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e1354",
  null
  
)

export default component.exports